import { ValueObject } from '@keyvue/one-api-client';
import { object, Schema, string } from 'yup';
import InboxIcon from '@keyvue/one-awesome-icons/icons/solid/inbox.svg?component';
import InboxOutIcon from '@keyvue/one-awesome-icons/icons/solid/inbox-out.svg?component';
import MessageExclamationIcon from '@keyvue/one-awesome-icons/icons/solid/message-exclamation.svg?component';
import StarIcon from '@keyvue/one-awesome-icons/icons/solid/star.svg?component';

class InboxFolder extends ValueObject {
    static fromRouteSlug(routeSlug: string) {
        return {
            'conversations': InboxFolder.CONVERSATIONS,
            'sent-emails': InboxFolder.SENT_EMAILS,
            'spam': InboxFolder.SPAM,
            'favorites': InboxFolder.FAVORITES,
        }[routeSlug];
    }

    get label(): string {
        return {
            [InboxFolder.CONVERSATIONS.value]: 'Gesprekken',
            [InboxFolder.SENT_EMAILS.value]: 'Verzonden e-mails',
            [InboxFolder.SPAM.value]: 'Spam',
            [InboxFolder.FAVORITES.value]: 'Favorieten',
        }[this.value];
    }

    get routeSlug(): string {
        return {
            [InboxFolder.CONVERSATIONS.value]: 'conversations',
            [InboxFolder.SENT_EMAILS.value]: 'sent-emails',
            [InboxFolder.SPAM.value]: 'spam',
            [InboxFolder.FAVORITES.value]: 'favorites',
        }[this.value];
    }

    get icon(): any {
        return {
            [InboxFolder.CONVERSATIONS.value]: InboxIcon,
            [InboxFolder.SENT_EMAILS.value]: InboxOutIcon,
            [InboxFolder.SPAM.value]: MessageExclamationIcon,
            [InboxFolder.FAVORITES.value]: StarIcon,
        }[this.value];
    }

    // Some error about builded types not matching
    // @ts-ignore
    // eslint-disable-next-line
    get schemaConfig(): Schema {
        return InboxFolder.validationSchema;
    }

    static get validationSchema(): Schema {
        return object({
            value: string().oneOf(
                InboxFolder.values.map((inboxFolder: InboxFolder) => inboxFolder.value),
            ),
        });
    }

    static get values() {
        return [
            InboxFolder.CONVERSATIONS,
            InboxFolder.SENT_EMAILS,
            InboxFolder.SPAM,
            InboxFolder.FAVORITES,
        ];
    }

    static CONVERSATIONS = new InboxFolder('conversations');

    static SENT_EMAILS = new InboxFolder('sentEmails');

    static SPAM = new InboxFolder('spam');

    static FAVORITES = new InboxFolder('favorites');
}

export default InboxFolder;
